import React from 'react';
import Logo from './Logo';

const DetailPembayaran = ({ paymentData, onBack, activeBottomTab, setActiveBottomTab }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Mobile Wrapper */}
      <div className="max-w-lg mx-auto bg-white shadow-2xl min-h-screen">
        
        {/* Header */}
        <header className="px-4 pt-8 pb-4 bg-white border-b border-gray-100">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <button 
                onClick={onBack}
                className="p-2 rounded-full hover:bg-gray-100 transition-colors"
              >
                <i className="fa-solid fa-arrow-left text-primary text-xl"></i>
              </button>
              <div className="flex items-center space-x-2">
                <Logo size="small" showText={false} />
                <span className="font-bold text-primary text-lg">Detail Pembayaran</span>
              </div>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="pb-24 bg-gray-50">
          {/* Bukti Pembayaran Section */}
          <section className="px-4 pt-6">
            <div className="bg-accent/10 rounded-2xl shadow-lg overflow-hidden">
              <div className="bg-accent p-3">
                <h3 className="text-primary font-bold text-center">Bukti Pembayaran</h3>
              </div>
              <div className="p-4">
                {/* Mobile Transfer Screenshot */}
                <div className="bg-gray-100 rounded-xl p-4 text-center">
                  <div className="bg-white rounded-lg p-8 border-2 border-dashed border-gray-300">
                    {/* Phone mockup */}
                    <div className="bg-black rounded-3xl p-2 w-64 mx-auto">
                      <div className="bg-white rounded-2xl p-4 h-96 overflow-hidden">
                        {/* BCA watermark background */}
                        <div className="relative h-full bg-white">
                          <div className="absolute inset-0 opacity-5">
                            <div className="grid grid-cols-3 gap-4 h-full">
                              {[...Array(9)].map((_, i) => (
                                <div key={i} className="text-2xl font-bold text-gray-400">BCA</div>
                              ))}
                            </div>
                          </div>
                          
                          {/* Transfer content */}
                          <div className="relative z-10 p-4 h-full flex flex-col justify-between">
                            <div>
                              <p className="text-gray-600 text-xs">Dari Rekening</p>
                              <p className="text-primary font-semibold">{paymentData.transferData.fromAccount}</p>
                            </div>
                            
                            <div className="text-center">
                              <div className="bg-green-100 rounded-lg p-3 mb-3">
                                <div className="flex items-center justify-center space-x-2">
                                  <div className="bg-green-500 rounded-full w-6 h-6 flex items-center justify-center">
                                    <i className="fa-solid fa-check text-white text-xs"></i>
                                  </div>
                                  <span className="text-green-700 font-semibold text-sm">m-Transfer: BERHASIL</span>
                                </div>
                              </div>
                            </div>
                            
                            <div className="space-y-2">
                              <div>
                                <p className="text-gray-600 text-xs">Tanggal/Waktu</p>
                                <p className="text-primary font-semibold text-sm">{paymentData.transferData.dateTime}</p>
                              </div>
                              
                              <div>
                                <p className="text-gray-600 text-xs">Ke</p>
                                <p className="text-primary font-semibold text-sm">{paymentData.transferData.toAccount}</p>
                              </div>
                              
                              <div>
                                <p className="text-gray-600 text-xs">Jumlah</p>
                                <p className="text-primary font-bold text-lg">{paymentData.transferData.amount}</p>
                              </div>
                              
                              <div>
                                <p className="text-gray-600 text-xs">Deskripsi</p>
                                <p className="text-primary font-semibold text-sm">{paymentData.transferData.description}</p>
                              </div>
                            </div>
                            
                            {/* Action buttons */}
                            <div className="flex space-x-2 pt-4">
                              <button className="flex-1 bg-gray-100 text-gray-600 py-2 px-3 rounded-lg flex items-center justify-center space-x-1">
                                <i className="fa-solid fa-share text-xs"></i>
                              </button>
                              <button className="flex-1 bg-gray-100 text-gray-600 py-2 px-3 rounded-lg flex items-center justify-center space-x-1">
                                <i className="fa-solid fa-download text-xs"></i>
                              </button>
                              <button className="flex-1 bg-blue-500 text-white py-2 px-3 rounded-lg font-semibold text-sm">
                                OK
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Data Pembayar Section */}
          <section className="px-4 mt-4">
            <div className="bg-accent/10 rounded-2xl shadow-lg overflow-hidden">
              <div className="bg-accent p-3">
                <h3 className="text-primary font-bold text-center">Data Pembayar</h3>
              </div>
              <div className="p-4 space-y-3">
                <div className="flex justify-between">
                  <span className="text-gray-600 text-sm">Kode Bayar</span>
                  <span className="text-primary font-semibold text-sm">{paymentData.paymentCode}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600 text-sm">Nama Customer</span>
                  <span className="text-primary font-semibold text-sm">{paymentData.customerName}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600 text-sm">Ke Rekening</span>
                  <span className="text-primary font-semibold text-sm">{paymentData.toAccount}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600 text-sm">Jumlah Bayar</span>
                  <span className="text-primary font-semibold text-sm">{paymentData.paymentAmount}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600 text-sm">Tanggal Bayar</span>
                  <span className="text-primary font-semibold text-sm">{paymentData.paymentDate}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600 text-sm">Status</span>
                  <span className="text-green-600 font-semibold text-sm">{paymentData.statusDetail}</span>
                </div>
              </div>
            </div>
          </section>

          {/* Deskripsi Section */}
          <section className="px-4 mt-4">
            <div className="bg-accent/10 rounded-2xl shadow-lg overflow-hidden">
              <div className="bg-accent p-3">
                <h3 className="text-primary font-bold text-center">Deskripsi</h3>
              </div>
              <div className="p-4">
                <p className="text-gray-600 text-sm">{paymentData.description}</p>
              </div>
            </div>
          </section>
        </main>

        {/* Bottom Navigation */}
        <footer className="fixed bottom-0 left-0 right-0 max-w-lg mx-auto bg-white pt-2">
          <div className="bg-primary mx-4 mb-4 rounded-2xl shadow-lg">
            <div className="flex justify-around items-center h-20 text-white">
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'home' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => {
                  setActiveBottomTab('home');
                  onBack();
                }}
              >
                <i className="fa-solid fa-house text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Beranda</span>
              </span>
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'savings' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => {
                  setActiveBottomTab('savings');
                  onBack();
                }}
              >
                <i className="fa-solid fa-piggy-bank text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Tabungan</span>
              </span>
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'products' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => setActiveBottomTab('products')}
              >
                <i className="fa-solid fa-box-archive text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Produk</span>
              </span>
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'investment' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => {
                  setActiveBottomTab('investment');
                  onBack();
                }}
              >
                <i className="fa-solid fa-arrow-trend-up text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Investasi</span>
              </span>
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'account' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => {
                  setActiveBottomTab('account');
                  onBack();
                }}
              >
                <i className="fa-solid fa-user-circle text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Akun</span>
              </span>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default DetailPembayaran;
